/*******
* inmport all used javascript
*******/
import $ from 'jquery';
import config from './config';

import { Setup, Context } from '@nutshell/core';

/*******
* Add jQuery to the site
*******/
window.$ = $;
window.jQuery = $;

window.Context = Context;

/*******
* Apply javascript of the core
*******/
Setup.init();


/**
 * Include modules
 */

require('./modules/carousel');
require('./modules/cookieConsent');
require('./modules/contact');
require('./modules/demo');
require('./modules/menu');
require('./modules/signup');
require('./modules/meetup');

/**
* Node modules
**/
require('cookieconsent');

/**
* Foundation
**/
$(document).foundation();